import styled from 'styled-components';
import {
  alignItems,
  alignSelf,
  borderRadius,
  borders,
  boxShadow,
  color,
  display,
  flex,
  flexDirection,
  flexWrap,
  fontSize,
  height,
  justifyContent,
  maxWidth,
  minHeight,
  minWidth,
  order,
  overflow,
  position,
  space,
  width,
  zIndex,
} from 'styled-system';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';

const Box = styled.div<StyledSystemProps>`
  ${flex};
  ${space};
  ${color};
  ${order};
  ${width};
  ${zIndex};
  ${height};
  ${borders};
  ${display};
  ${fontSize};
  ${maxWidth};
  ${minWidth};
  ${overflow};
  ${position};
  ${flexWrap};
  ${minHeight};
  ${alignSelf};
  ${boxShadow};
  ${alignItems};
  ${borderRadius};
  ${flexDirection};
  ${justifyContent};
  box-sizing: border-box;
`;

export default Box;

Box.defaultProps = {
  display: 'flex',
  maxWidth: '100%',
  position: 'relative',
  flexDirection: 'column',
};
